import { titleCase } from './titleCase';

function humanizeItem(item: string): string {
  const itemClean = (
      item.split(/\./).pop() || ''  // Get the last part of the class name if fully qualified
    )
    .replace(/([a-z])([A-Z])/g, '$1 $2')    // Break up camel casing
    .replace(/[\_\-]/g, ' ')                // Break up underscores and dashes
    .replace(/\s\s+/g, ' ')                 // Replace multiple whitespace with one
    .trim();

  return titleCase(itemClean);
}

export function humanize(value: string): string;
export function humanize(value: string[]): string[];
export function humanize(value: string | string[]): string | string[] {
  if (!value) {
    return value;
  }

  if (Array.isArray(value)) {
    const values = value as string[];

    return values.map(item => humanizeItem(item));
  }

  return humanizeItem(value as string);
}



// WEBPACK FOOTER //
// ./src/gs-core/common/convert/humanize.ts